<template>
  <div class="main">
    <div>
      <!-- 二级路由 -->
      <!-- 保存已经失活的路由组件状态，如果访问过的路由组件，则再次访问时，不会触发组件的生命周期钩子 -->
      <!-- Home组件和Menu组件被缓存 -->
      <keep-alive include="Home,Menu">
        <router-view></router-view>
      </keep-alive>
    </div>

    <van-tabbar
      v-model="tabbarIndex"
      active-color="#0C34BA"
      :route="true"
    >
      <van-tabbar-item
        v-for="(item,index) in tabbarData"
        :badge=item.badge
        :key="index"
        :to="item.url"
      >
        <span>{{item.title}}</span>
        <template #icon="props">
          <img :src="props.active ? item.icon.active : item.icon.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 尾部tabbar索引值
      tabbarIndex: 0,
      tabbarData: [
        {
          title: "首页",
          icon: {
            // 在vue项目中，唯一可以外部访问的文件是static文件夹，src文件夹是不可以通过外部访问的，只能我们内部代码调用。
            // 使用require定义之后，就可以动态使用了
            active: require("../assets/images/home_active.png"),
            inactive: require("../assets/images/home.png"),
          },
          url: {
            name: "Home",
          },
        },
        {
          title: "菜单",
          icon: {
            active: require("../assets/images/menu_active.png"),
            inactive: require("../assets/images/menu.png"),
          },
          url: {
            name: "Menu",
          },
        },
        {
          title: "购物袋",
          icon: {
            active: require("../assets/images/shopbag_active.png"),
            inactive: require("../assets/images/shopbag.png"),
          },
          badge: 0,
          url: {
            name: "Shopbag",
          },
        },
        {
          title: "我的",
          icon: {
            active: require("../assets/images/my_active.png"),
            inactive: require("../assets/images/my.png"),
          },
          url: {
            name: "My",
          },
        },
      ],
      shopbagData: [],
    };
  },
  created() {
    this.findShopbag();
  },
  methods: {
    // 查询购物袋
    findShopbag() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      this.axios({
        method: "GET",
        url: "/findAllShopcart",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 5000) {
            result.data.result.map((v) => {
              v.isCheck = false;
            });
            this.shopbagData = result.data.result;
            this.tabbarData[2].badge = this.shopbagData.length;
          } else {
            this.$toast(result.data.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-bottom: 50px;
}

/deep/ .van-info {
  background-color: #0c34ba;
}
</style>